module.exports = __webpack_public_path__ + "static/media/Apr_2026_5.a1289a1c.webp";